import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PublicRouteProps {
  children: ReactElement;
  allowAuthenticated?: boolean; // New prop to allow authenticated users
}

const PublicRoute = ({ children, allowAuthenticated = false }: PublicRouteProps): ReactElement => {
  const isAuthenticated = localStorage.getItem("AUTHDATA") !== null;
  const location = useLocation();
  
  if (allowAuthenticated) {
    return children;
  }
  
  // Otherwise, redirect authenticated users to dashboard (for login/register pages)
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
